import { Box, Checkbox } from '@factorialco/deprecated-design-system'
import { FormikProps, FormikProvider } from 'formik'
import { AtsQuestionTypeEnum } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import SelectField from 'modules/core/components/SelectField'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { OptionsField } from 'modules/ats/components/Questions/OptionsField'
import { getQuestionTypeLabel } from 'modules/ats/lib/utils/customQuestion'

import { UpdateQuestionFormValues } from './QuestionFormValues'

interface Props {
  form: FormikProps<UpdateQuestionFormValues>
  label: string
  questionType: AtsQuestionTypeEnum
  hasOptions: boolean
  mandatory: boolean
  template?: boolean
  canSaveTemplates: boolean
  saveAsTemplate: boolean
  setSaveAsTemplate: (value: boolean) => void
}

export const EditQuestion = ({
  form,
  label,
  questionType,
  hasOptions,
  mandatory,
  template,
  canSaveTemplates,
  saveAsTemplate,
  setSaveAsTemplate,
}: Props) => {
  return (
    <FormikProvider value={form}>
      <Box gap="s16">
        <TextField
          label={i18n.t(
            'ats.job_posting_settings.application_form.custom_questions.question_label'
          )}
          value={form.values.label ?? label}
          onChange={(new_label) => form.setFieldValue('label', new_label, false)}
          error={form.errors.label}
        />

        <SelectField
          label={i18n.t('ats.job_posting_settings.application_form.custom_questions.question_type')}
          value={questionType}
          options={[
            {
              label: getQuestionTypeLabel(questionType),
              value: questionType,
            },
          ]}
          showOriginalLabelText
          readonly
        />

        {hasOptions && <OptionsField form={form} />}

        <Checkbox
          label={i18n.t('ats.questions.mandatory')}
          checked={form.values.mandatory ?? mandatory}
          onChange={(event) => form.setFieldValue('mandatory', event.target.checked, false)}
        />

        {hasOptions && (
          <Checkbox
            label={i18n.t(
              'ats.job_posting_settings.application_form.custom_questions.auto_disqualify'
            )}
            checked={form.values.autoDisqualify ?? false}
            onChange={(event) => form.setFieldValue('autoDisqualify', event.target.checked, false)}
          />
        )}

        {canSaveTemplates && (
          <Checkbox
            label={i18n.t('ats.questions.save_as_template')}
            checked={saveAsTemplate}
            onChange={(event) => setSaveAsTemplate(event.target.checked)}
          />
        )}

        {!template && (
          <Callout
            type="warning"
            description={i18n.t(
              'ats.job_posting_settings.application_form.custom_questions.edit_modal_warning'
            )}
          />
        )}
      </Box>
    </FormikProvider>
  )
}
